import { render } from "./MenuContainer.vue?vue&type=template&id=2834a14a"
import script from "./MenuContainer.vue?vue&type=script&lang=js"
export * from "./MenuContainer.vue?vue&type=script&lang=js"

import "./MenuContainer.vue?vue&type=style&index=0&id=2834a14a&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__